export enum TemplateId {
    BUNDLE = 'bundle',
    HEADER = 'header',
    CONTENT = 'content',
}
